module.exports = __webpack_public_path__ + "img/11_22.f1228089.png";